export default "__VITE_ASSET__BqxUFs03__"